export default "__VITE_ASSET__27a6d609__"